import { BaseService } from './base-service';
export class AuthService {
    static login(dto) {
        return BaseService.post(`auth/login`, dto);
    }
    static refresh() {
        return BaseService.post(`auth/refresh`, {});
    }
    static logout() {
        return BaseService.post(`auth/logout`, {});
    }
}
